var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapper_container ? '' : 'container'},[_c('lazy-image',{staticClass:"full-width-image",attrs:{"src":_vm.image_src,"cover_img":"","lazy_src":_vm.image_lazy_src,"alt":"article image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }